import { bind, Component, h, tag } from "omi";

import { useCourses } from "@/wc/components/nw-nav/store/queries/courses.ts";
import { IconName, NWButton, NWError, NWLoadingSpinner } from "@/wc/components";
import { tailwind } from "@/tailwind";

import { useRecommendedTopics } from "../../store/queries/recommendedTopics.ts";
import { formatCategory, isCourse, Topic, toTopic } from "../../store/models.ts";
import { useUserPreferencesMutation } from "../../store/mutations";
import { ALL_CATEGORY, NavStore, NavView } from "../../store";
import { getIconForCategory } from "../../utils.ts";
import { FilterCheckbox } from "./filter-checkbox.tsx";

type Props = {};

@tag("nav-category-selection")
export class NavCategorySelection extends Component<Props> {
  static css = [tailwind];

  private courses = useCourses();
  private recommendedTopics = useRecommendedTopics();

  private userPrefsMutation = useUserPreferencesMutation();
  private ALL_TOPIC = toTopic(ALL_CATEGORY);

  @bind
  private handleOnSelect(topic: Topic) {
    NavStore.selectTopic(topic);
  }

  @bind
  private async handleGenerateCourse() {
    if (NavStore.selectedTopics.value.length === 0) {
      return;
    }

    const categories = NavStore.getSelectedTopicsAsCategories();
    this.userPrefsMutation.mutate({ selectedCategories: categories });
    NavStore.progressTo(NavView.TRACK_OVERVIEW);
    import("@/services/analyticsService").then(({ useAnalyticsService }) => {
      useAnalyticsService().trackTimeSwitcherTopicChanged(categories);
    });
  }

  render() {
    const isLoading = this.recommendedTopics.isLoading.value;
    const hasError = !!this.recommendedTopics.error.value || this.recommendedTopics.data.value?.length === 0;

    return (
      <div class="h-full flex flex-col items-center justify-center text-center animate-slideInLeftFast">
        {hasError && <NWError />}
        {!hasError && isLoading && <NWLoadingSpinner size="md" />}
        {!isLoading && !hasError && (
          <>
            <h3 class="text-lg">AWS topics I want to learn...</h3>
            <div class="mt-3 mb-6 gap-2 flex flex-wrap justify-center">
              <FilterCheckbox
                onClick={() => this.handleOnSelect(this.ALL_TOPIC)}
                selected={NavStore.isTopicSelected(this.ALL_TOPIC)}
              >
                {formatCategory(ALL_CATEGORY)}
              </FilterCheckbox>

              {this.recommendedTopics.data.value?.map(topic => {
                const title = isCourse(topic) ? this.courses.getCourseTitle(topic.value) : topic.value;
                const icon = isCourse(topic)
                  ? topic.value.metadata!.icon!
                  : (getIconForCategory(topic.value) as IconName);

                return (
                  <FilterCheckbox
                    key={topic.value}
                    onClick={() => this.handleOnSelect(topic)}
                    selected={NavStore.isTopicSelected(topic)}
                    icon={icon as IconName}
                  >
                    {title}
                  </FilterCheckbox>
                );
              })}
            </div>
            <NWButton
              type="primary"
              class="w-full"
              size="full"
              onClick={this.handleGenerateCourse}
              disabled={NavStore.selectedTopics.value.length === 0}
            >
              Generate course
            </NWButton>
          </>
        )}
      </div>
    );
  }
}
